/* v16 behaviour. v15-prefixed selectors. Motion respects prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. floating pill nav ---- */
  var pill = document.querySelector('.v15pill');
  if (pill) {
    var shown = false;
    var onScroll = function () {
      var past = window.scrollY > 420;
      if (past !== shown) { shown = past; pill.classList.toggle('on', past); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 2. editorial scroll reveal (below the fold only — the hero is never opacity-gated,
     because an element at opacity:0 is not an LCP candidate) ---- */
  var rises = document.querySelectorAll('.v15rise');
  if (rises.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      rises.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var d = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { el.classList.add('in'); }, d);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      rises.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- 3. ingredient transparency modals ---- */
  document.querySelectorAll('[data-v15-modal]').forEach(function (btn) {
    btn.addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      var dlg = document.getElementById(btn.getAttribute('data-v15-modal'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });
  document.querySelectorAll('dialog.v15modal').forEach(function (dlg) {
    dlg.querySelectorAll('[data-v15-close]').forEach(function (c) {
      c.addEventListener('click', function () { dlg.close(); });
    });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
  });

  /* ---- 4. routine builder ---- */
  var rb = document.querySelector('[data-v15-builder]');
  if (rb) {
    var currency = rb.getAttribute('data-currency') || 'USD';
    var fmt = function (cents) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    var opts = Array.prototype.slice.call(rb.querySelectorAll('.v15opt'));
    var totalEl = rb.querySelector('[data-v15-total]');
    var metaEl = rb.querySelector('[data-v15-meta]');
    var addBtn = rb.querySelector('[data-v15-add]');

    var recalc = function () {
      var cents = 0, perDay = 0, n = 0, unknown = false;
      opts.forEach(function (o) {
        if (o.getAttribute('aria-pressed') !== 'true') return;
        var price = parseInt(o.getAttribute('data-price') || '0', 10);
        var days = parseInt(o.getAttribute('data-days') || '0', 10);
        cents += price;
        /* Each product's own daily cost, summed. Dividing basket total by the longest supply
           would understate a short-supply item like elixir at 14 days. Math.floor matches the
           Liquid divided_by on the cards to the cent. */
        if (days > 0) { perDay += Math.floor(price / days); } else { unknown = true; }
        n++;
      });
      totalEl.textContent = fmt(cents);
      metaEl.textContent = n
        ? n + (n === 1 ? ' product · ' : ' products · ') + fmt(perDay) + ' a day' + (unknown ? ' (partial)' : '')
        : 'nothing selected';
      addBtn.disabled = n === 0;
      addBtn.textContent = n > 1 ? 'add ' + n + ' to bag' : 'add to bag';
    };

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        o.setAttribute('aria-pressed', o.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        recalc();
      });
    });

    addBtn.addEventListener('click', function () {
      var items = opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; })
        .map(function (o) { return { id: parseInt(o.getAttribute('data-variant'), 10), quantity: 1 }; });
      if (!items.length) return;
      addBtn.disabled = true; addBtn.textContent = 'adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'could not add — try again'; });
    });

    recalc();
  }

  /* ---- 5. bag count ---- */
  var bag = document.querySelector('[data-v15-bag]');
  if (bag) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { bag.textContent = 'bag (' + (c.item_count || 0) + ')'; })
      .catch(function () { });
  }

  /* ---- 6. exit intent: quiet corner card, once per session, real active code ---- */
  var exit = document.querySelector('[data-v15-exit]');
  if (exit) {
    var KEY = 'v15-exit-seen';
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) { seen = false; }

    var dismiss = function () {
      exit.classList.remove('on');
      setTimeout(function () { exit.hidden = true; }, 300);
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { }
    };

    var reveal = function () {
      if (seen || !exit.hidden) return;
      seen = true;
      exit.hidden = false;
      /* setTimeout, not requestAnimationFrame: rAF is throttled or skipped entirely in a
         backgrounded tab, which is precisely the moment this fires. */
      setTimeout(function () { exit.classList.add('on'); }, 24);
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { }
    };

    /* Desktop only: cursor leaving through the top of the viewport. Never on touch, where there
       is no such gesture and an overlay is just an interrupt. */
    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', function (ev) {
        if (ev.relatedTarget || ev.toElement) return;
        if (ev.clientY > 8) return;
        reveal();
      });
    }

    exit.querySelector('[data-v15-exit-close]').addEventListener('click', dismiss);

    var copyBtn = exit.querySelector('[data-v15-copy]');
    copyBtn.addEventListener('click', function () {
      var code = exit.querySelector('[data-v15-code]').textContent.trim();
      var done = function () { copyBtn.textContent = 'copied'; setTimeout(function () { copyBtn.textContent = 'copy'; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { copyBtn.textContent = code; });
      } else { copyBtn.textContent = code; }
    });
  }
})();
